import { useTranslation } from 'react-i18next';
import {
  showCartToast,
  showErrorToast,
  showInfoToast,
  showSuccessToast,
} from '../../../../common/global/helpers';
import useBreakpoints from '../../../../common/hooks/useBreakpoints';
import Button from '../../../../common/widgets/Button';
import ExpandablePanel from '../../../../common/widgets/ExpandablePanel';
import Icons from '../../../../common/widgets/Icons';
import {
  Notification,
  NotificationType,
} from '../../../../common/widgets/Notification';
import { resources } from '../../resources/resources';
import IconsShowcase from './IconsShowcase';

{
  /* Stacked carousel export*/
}

export default function DemoPage() {
  const { t: translations } = useTranslation();
  const { isTablet, isMobile } = useBreakpoints();

  return (
    <>
      {isMobile && <span>Mobile</span>}
      {isTablet && <span>Tablet</span>}
      {/*
      Single column layout
      <section className="section-main section-full">
        <div className="container"></div>
      </section>
      */}

      {/*
      Two columns layout
      <section className="section-main section-actions">
        <div className="container">
          <div className="area-actions"></div>
          <div className="area-content"></div>
        </div>
      </section>
      */}

      {/* Cards carousel */}
      <section className="section-main section-actions my-account-page my-account-dashboard">
        <div className="container">
          <div className="area-actions"></div>
          <div className="area-content">
            <div className="row mydash-info">
              <div className="col col-4 col-lg-6 col-md-6 col-sm-12">
                <div className="panel padding-xl">
                  <div className="mydash-panel-header">
                    <h2 className="mydash-title">My dash title</h2>
                  </div>
                </div>
              </div>

              <div className="col col-8 col-lg-6 col-md-6 col-sm-12"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Content of demo page starts here */}
      <section className="section-main section-actions">
        <div className="container">
          <div className="area-actions">
            {/* Left panel */}

            {/* Categories navigation */}
            <div className="action-panel">
              <div className="action-panel-title">
                <span>Categorii</span>
              </div>
              <div className="action-panel-content secondary-nav">
                <ul>
                  <li className="active">
                    <a>Servicii medicale activa</a>
                  </li>
                  <li>
                    <a>Pensii private categorie lvl1 pe doua randuri</a>
                  </li>
                  <li className="active">
                    <span>Dezvoltare activa</span>
                    <ul>
                      <li>
                        <a>
                          Bookster&nbsp;<span>(2)</span>
                        </a>
                      </li>
                      <li>
                        <a>
                          Cultura, experiente & timp liber categorie lvl2 pe
                          doua randuri&nbsp;<span>(99)</span>
                        </a>
                      </li>
                      <li>
                        <a>
                          Copii & Parinti&nbsp;<span>(2)</span>
                        </a>
                      </li>
                      <li className="active">
                        <a>
                          Sport&nbsp;<span>(12)</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>

            {/* My account panel */}
            <div className="action-panel">
              <div className="action-panel-content account-nav">
                <ul>
                  <li className="active">
                    <a>
                      <span className="account-nav-icon">
                        <Icons.Dashboard />
                      </span>
                      <span className="account-nav-item">Contul tau</span>
                    </a>
                  </li>
                  <li>
                    <a>
                      <span className="account-nav-icon">
                        <Icons.CalendarEdit />
                      </span>
                      <span className="account-nav-item">
                        Prezenta si pontaj
                      </span>
                    </a>
                  </li>
                  <li>
                    <a>
                      <span className="account-nav-icon">
                        <Icons.Notification />
                      </span>
                      <span className="account-nav-item">Notificari</span>
                      <span className="account-nav-alert">
                        <Icons.Alert />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a>
                      <span className="account-nav-icon">
                        <Icons.Favorite />
                      </span>
                      <span className="account-nav-item">Favorite</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Filter panel */}
            <div className="action-panel expandable">
              <div className="action-panel-title">
                <span>Nivel taxare</span>
                <span className="action-panel-expand">
                  <Icons.ArrowUp />
                </span>
              </div>
              <div className="action-panel-content">Content</div>
            </div>

            {/* Filter panel collapsed */}
            <div className="action-panel expandable collapsed">
              <div className="action-panel-title">
                <span>Nivel taxare - collapsed</span>
                <span className="action-panel-expand">
                  <Icons.ArrowUp />
                </span>
              </div>
              <div className="action-panel-content">Content</div>
            </div>

            <ExpandablePanel title={'Test Expand Collapse'}>
              <div>
                <p>First</p>
                <p>Second</p>
              </div>
            </ExpandablePanel>
          </div>

          <div className="area-content">
            <h1>Demo and components page</h1>

            {/* Categories nav - for styles */}
            <div className="category-panel"></div>

            {/* Typography */}
            <div className="panel">
              <h2>Typography</h2>
              <h1>H1 lorem ipsum dolor sit amet ăîșțâĂÎȘȚÂ</h1>
              <h2>H2 lorem ipsum dolor sit amet ăîșțâĂÎȘȚÂ</h2>
              <h3>H3 lorem ipsum dolor sit amet ăîșțâĂÎȘȚÂ</h3>
              <h4>H4 lorem ipsum dolor sit amet ăîșțâĂÎȘȚÂ</h4>
              <h5>H5 lorem ipsum dolor sit amet ăîșțâĂÎȘȚÂ</h5>
              <p>Paragraph - lorem ipsum dolor sit amet ăîșțâĂÎȘȚÂ</p>
              <p className="small-text">
                H1 lorem ipsum dolor sit amet ăîșțâĂÎȘȚÂ
              </p>
              <h2
                style={{
                  marginTop: 60,
                }}
              >
                Diacritics check
              </h2>
              <p
                style={{
                  fontFamily: 'Edenred, serif',
                  fontWeight: 300,
                  fontSize: 30,
                }}
              >
                Light 300 - lorem ipsum dolor sit amet ăîșțâĂÎȘȚÂ
              </p>
              <p
                style={{
                  fontFamily: 'Edenred, serif',
                  fontWeight: 300,
                  fontSize: 30,
                  fontStyle: 'italic',
                }}
              >
                Light 300 italic - lorem ipsum dolor sit amet ăîșțâĂÎȘȚÂ
              </p>
              <p
                style={{
                  fontFamily: 'Edenred, serif',
                  fontWeight: 400,
                  fontSize: 30,
                }}
              >
                Regular 400 - lorem ipsum dolor sit amet ăîșțâĂÎȘȚÂ
              </p>
              <p
                style={{
                  fontFamily: 'Edenred, serif',
                  fontWeight: 500,
                  fontSize: 30,
                }}
              >
                Medium 500 - lorem ipsum dolor sit amet ăîșțâĂÎȘȚÂ
              </p>
              <p
                style={{
                  fontFamily: 'Edenred, serif',
                  fontWeight: 700,
                  fontSize: 30,
                }}
              >
                Bold 700 - lorem ipsum dolor sit amet ăîșțâĂÎȘȚÂ
              </p>
              <p
                style={{
                  fontFamily: 'Edenred, serif',
                  fontWeight: 900,
                  fontSize: 30,
                }}
              >
                Black 900 - lorem ipsum dolor sit amet ăîșțâĂÎȘȚÂ
              </p>
            </div>

            <h2>Card system showcase</h2>

            {/* Products cards */}
            <h3>Products cards</h3>
            <div
              style={{
                marginBottom: 30,
              }}
            >
              <div className="card-list card-list-5 card-list-lg-5 card-list-md-4 card-list-sm-3 card-list-xs-2 card-list-xxs-1">
                <a className="card product-card">
                  <div className="card-img">
                    <img src="https://benefitonline.ro/sites/default/files/2022-12/employer-benefits-3.png" />
                    <div className="card-promo">
                      <div>-10%</div>
                      <div>Taxe salariale 41.5%</div>
                    </div>
                    <button className="btn btn-card-favorite">
                      <span className="btn-icon">
                        <Icons.CardFavorite />
                      </span>
                    </button>
                  </div>
                  <div className="card-details">
                    <div className="card-title">
                      Title - Lorem ipsum dolor sit amet, consectetur adipiscing
                      elit. Sed eget lacus lacinia, gravida eros a, iaculis
                      lectus. Praesent eu orci vel arcu consequat gravida vel et
                      dolor
                    </div>
                    <div className="card-value">
                      400<sup>ron</sup> - 800<sup>ron</sup>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            {/* Products cards with actions */}
            <h3>Products cards with actions</h3>
            <div
              style={{
                marginBottom: 30,
              }}
            >
              <div className="card-list card-list-6 card-list-lg-5 card-list-md-4 card-list-sm-3 card-list-xs-2 card-list-xxs-1">
                <div className="card product-card">
                  <div className="card-img">
                    <img src="https://benefitonline.ro/sites/default/files/2022-12/employer-benefits-2.png" />
                    <div className="card-promo">
                      <div>-10%</div>
                    </div>
                  </div>
                  <div className="card-details">
                    <div className="card-title">Comfort Extra</div>
                    <div className="card-info">Expira in noiembrie, 2023</div>
                    <div className="card-actions">
                      <button className="btn-link">
                        <span className="btn-icon">
                          <Icons.ArrowButton />
                        </span>
                        <span className="btn-text">Intrerupe</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card product-card card-small">
                  <div className="card-img">
                    <img src="https://benefitonline.ro/sites/default/files/2022-12/employer-benefits-2.png" />
                    <div className="card-promo">
                      <div>-10%</div>
                    </div>
                  </div>
                  <div className="card-details">
                    <div className="card-title">Small card</div>
                    <div className="card-info">Expira in noiembrie, 2023</div>
                    <div className="card-actions">
                      <button className="btn-link">
                        <span className="btn-icon">
                          <Icons.ArrowButton />
                        </span>
                        <span className="btn-text">Intrerupe</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Products cards with links and actions */}
            <h3>Products cards with links and actions</h3>
            <div
              style={{
                marginBottom: 30,
              }}
            >
              <div className="card-list card-list-6 card-list-lg-5 card-list-md-4 card-list-sm-3 card-list-xs-2 card-list-xxs-1">
                <div className="card product-card link-action">
                  <a className="card-img">
                    <img src="https://benefitonline.ro/sites/default/files/2022-12/employer-benefits-2.png" />
                  </a>
                  <div className="card-details">
                    <a className="card-title">Comfort Extra</a>
                    <div className="card-info">Expira in noiembrie, 2023</div>
                    <div className="card-actions">
                      <button className="btn-link">
                        <span className="btn-icon">
                          <Icons.ArrowButton />
                        </span>
                        <span className="btn-text">Intrerupe</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Categories cards */}
            <h3>Categories cards</h3>
            <div
              style={{
                marginBottom: 30,
              }}
            >
              <div className="card-list card-list-6 card-list-lg-4">
                <a className="card category-card">
                  <div className="card-img">
                    <img src="https://benefitonline.ro/sites/default/files/2022-12/employer-benefits-2.png" />
                  </div>
                  <div className="card-details">
                    <div className="card-title">
                      Evenimente / Team building-uri
                    </div>
                  </div>
                </a>
              </div>
            </div>

            {/* Brands cards */}
            <h3>Brands cards</h3>
            <div
              style={{
                marginBottom: 30,
              }}
            >
              <div className="card-list card-list-6 card-list-lg-4">
                <a className="card brand-card">
                  <div className="card-img">
                    <img src="https://cdn.flip.ro/website/campaigns/LOGOS/logo_flip.svg" />
                  </div>
                </a>
                <a className="card brand-card">
                  <div className="card-img">
                    <img src="https://epicvisits.com/static/media/Ev_negativ.1114a7c1.png" />
                  </div>
                </a>
                <a className="card brand-card">
                  <div className="card-img">
                    <img src="https://www.dalecarnegie.com/static/dalecarnegie/DcLogoWide.svg" />
                  </div>
                </a>
                <a className="card brand-card">
                  <div className="card-img">
                    <img src="https://razvanidicel.ro/cdn/shop/files/Logo__RazvanIdicel_positive_e747efea-8be6-4f47-8149-f5c4b7493e35_400x.png?v=1630582835" />
                  </div>
                </a>
                <a className="card brand-card">
                  <div className="card-img">
                    <img src="https://upload.wikimedia.org/wikipedia/ro/8/87/NBA_Logo.svg" />
                  </div>
                </a>
              </div>
            </div>

            {/* Favorite buttons*/}
            <h3>Favorite button</h3>
            <div
              style={{
                marginBottom: 30,
              }}
            >
              <button className="btn btn-card-favorite">
                <span className="btn-icon">
                  <Icons.CardFavorite />
                </span>
              </button>
              <button className="btn btn-card-favorite active">
                <span className="btn-icon">
                  <Icons.CardFavorite />
                </span>
              </button>
            </div>

            {/* Title with button */}
            <section className="page-section mb-60">
              <h2 className="section-title">
                <span>Titlu sectiune</span>
                <span className="see-all-action">
                  <Button
                    className="btn-link see-all-btn"
                    icon={<Icons.ArrowButton />}
                  >
                    <span className="btn-text">Vezi toate</span>
                  </Button>
                </span>
              </h2>
            </section>

            {/* Title with mobile back button */}
            <section className="page-section mb-60">
              <h1 className="title-back-btn">
                {isTablet && (
                  <a className="btn btn-black-mobile">
                    <span className="btn-icon">
                      <Icons.ArrowBackMobile />
                    </span>
                  </a>
                )}
                Title with mobile back button
              </h1>
            </section>

            <section className="page-section mb-60">
              {/* Panel with back button */}
              <div className="panel">
                {/* Use the wrapper when you neeed margin bottom of 15px; */}
                <div className="btn-panel-back-wrapper">
                  <a className="btn btn-panel-back">
                    <span className="btn-text">
                      {translations(resources.back)}
                    </span>
                  </a>
                </div>
                <h2>Panel with back button</h2>
              </div>
            </section>

            {/* Icons showcase */}
            <div className="panel">
              <h2>Icons</h2>
              <IconsShowcase />
            </div>

            {/* Buttons showcase */}
            <div className="panel">
              <h2>Buttons</h2>
              <h3>Medium buttons</h3>
              {/* Medium (default) buttons */}
              {/* Buttons text only */}
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 10,
                  marginBottom: 20,
                }}
              >
                <button className="btn">
                  <span className="btn-text">.btn</span>
                </button>
                <button className="btn" disabled={true}>
                  <span className="btn-text">disabled .btn</span>
                </button>
                <a className="btn">
                  <span className="btn-text">.btn</span>
                </a>
                <button className="btn btn-outline">
                  <span className="btn-text">.btn .btn-outline</span>
                </button>
                <button className="btn btn-outline" disabled={true}>
                  <span className="btn-text">disabled .btn .btn-outline</span>
                </button>
                <a className="btn btn-outline">
                  <span className="btn-text">.btn .btn-outline</span>
                </a>
                <button className="btn btn-solid">
                  <span className="btn-text">.btn .btn-solid</span>
                </button>
                <button className="btn btn-solid" disabled={true}>
                  <span className="btn-text">disabled .btn .btn-solid</span>
                </button>
                <a className="btn btn-solid">
                  <span className="btn-text">.btn .btn-solid</span>
                </a>
              </div>
              {/* Buttons text and icon */}
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 10,
                  marginBottom: 20,
                }}
              >
                <button className="btn">
                  <span className="btn-icon">
                    <Icons.Add />
                  </span>
                  <span className="btn-text">.btn</span>
                </button>
                <button className="btn" disabled={true}>
                  <span className="btn-icon">
                    <Icons.Add />
                  </span>
                  <span className="btn-text">disabled .btn</span>
                </button>
                <a className="btn">
                  <span className="btn-icon">
                    <Icons.Padlock />
                  </span>
                  <span className="btn-text">.btn</span>
                </a>
                <button className="btn btn-outline">
                  <span className="btn-icon">
                    <Icons.ArrowButton />
                  </span>
                  <span className="btn-text">.btn .btn-outline</span>
                </button>
                <button className="btn btn-outline" disabled={true}>
                  <span className="btn-icon">
                    <Icons.ArrowButton />
                  </span>
                  <span className="btn-text">disabled .btn .btn-outline</span>
                </button>
                <a className="btn btn-outline">
                  <span className="btn-icon">
                    <Icons.Check />
                  </span>
                  <span className="btn-text">.btn .btn-outline</span>
                </a>
                <button className="btn btn-solid">
                  <span className="btn-icon">
                    <Icons.Send />
                  </span>
                  <span className="btn-text">.btn .btn-solid</span>
                </button>
                <button className="btn btn-solid" disabled={true}>
                  <span className="btn-icon">
                    <Icons.Send />
                  </span>
                  <span className="btn-text">disabled .btn .btn-solid</span>
                </button>
                <a className="btn btn-solid">
                  <span className="btn-icon">
                    <Icons.Voucher />
                  </span>
                  <span className="btn-text">.btn .btn-solid</span>
                </a>
              </div>
              <h3>Large buttons</h3>
              {/* Large buttons */}
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 10,
                  marginBottom: 20,
                }}
              >
                <button className="btn btn-lg">
                  <span className="btn-icon">
                    <Icons.Add />
                  </span>
                  <span className="btn-text">.btn .btn-lg</span>
                </button>
                <button className="btn btn-outline btn-lg">
                  <span className="btn-icon">
                    <Icons.ArrowButton />
                  </span>
                  <span className="btn-text">.btn .btn-outline .btn-lg</span>
                </button>
                <button className="btn btn-solid btn-lg">
                  <span className="btn-icon">
                    <Icons.Send />
                  </span>
                  <span className="btn-text">.btn .btn-solid .btn-lg</span>
                </button>
              </div>
              {/* Full buttons */}
              <h3>Full buttons</h3>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 10,
                  marginBottom: 20,
                }}
              >
                <button className="btn btn-outline btn-lg btn-full">
                  <span className="btn-icon">
                    <Icons.ArrowButton />
                  </span>
                  <span className="btn-text">
                    .btn .btn-outline .btn-lg .btn-full
                  </span>
                </button>
                <button className="btn btn-solid btn-lg btn-full">
                  <span className="btn-icon">
                    <Icons.Send />
                  </span>
                  <span className="btn-text">
                    .btn .btn-solid .btn-lg .btn-full
                  </span>
                </button>
              </div>
              {/* Small buttons */}
              <h3>Small buttons</h3>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 10,
                  marginBottom: 20,
                }}
              >
                <button className="btn btn-sm">
                  <span className="btn-icon">
                    <Icons.Add />
                  </span>
                  <span className="btn-text">.btn .btn-sm</span>
                </button>
                <button className="btn btn-outline btn-sm">
                  <span className="btn-icon">
                    <Icons.ArrowButton />
                  </span>
                  <span className="btn-text">.btn .btn-outline .btn-sm</span>
                </button>
                <button className="btn btn-solid btn-sm">
                  <span className="btn-icon">
                    <Icons.Send />
                  </span>
                  <span className="btn-text">.btn .btn-solid .btn-sm</span>
                </button>
              </div>
              {/* Text buttons */}
              <h3>Text buttons</h3>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 10,
                  marginBottom: 20,
                }}
              >
                <button className="btn-link">
                  <span className="btn-icon">
                    <Icons.Add />
                  </span>
                  <span className="btn-text">.btn-link</span>
                </button>
                <button className="btn-link" disabled={true}>
                  <span className="btn-icon">
                    <Icons.Send />
                  </span>
                  <span className="btn-text">disabled .btn-link</span>
                </button>
              </div>
            </div>

            {/* Custom scrollbar */}
            <div className="panel">
              <h2>Custom scrollbar</h2>

              <div
                className="styled-scrollbar"
                style={{
                  display: 'block',
                  height: '100px',
                }}
              >
                <p
                  style={{
                    display: 'block',
                    height: '500px',
                  }}
                >
                  Add class <strong>custom-scroll</strong> on parent element
                </p>
              </div>
            </div>

            {/* Custom scrollbar with left thumb */}
            <div className="panel">
              <h2>Custom scrollbar with left thumb</h2>

              <div
                className="styled-scrollbar-left"
                style={{
                  display: 'block',
                  height: '100px',
                }}
              >
                <p
                  style={{
                    display: 'block',
                    height: '500px',
                  }}
                >
                  Add class <strong>custom-scroll-left</strong> on parent
                  element
                </p>
              </div>
            </div>

            <div style={{ paddingBlock: '40px' }}>
              <h2>Notifications and toasts</h2>
              <div style={{ paddingBlockEnd: '20px' }}>
                {/* Notifications */}
                <Notification
                  type={NotificationType.Error}
                  messages={[
                    {
                      message:
                        'Error notification multiple messages, Message 1 Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent malesuada libero id odio interdum volutpat. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Praesent vel lectus in mauris viverra venenatis. Nulla sed elit nisl. Cras vitae est varius, vestibulum neque non, accumsan mi. Ut at nulla sagittis, posuere lacus sit amet, lobortis arcu. Donec rhoncus sem vitae elit vehicula hendrerit. Duis ac arcu malesuada magna sodales sollicitudin. Vestibulum luctus sollicitudin arcu, at posuere libero tincidunt et. Curabitur blandit tincidunt maximus. Nam leo urna, venenatis fermentum est sed, sagittis cursus justo.',
                      onShowDetailsClick: () => {},
                    },
                    {
                      message:
                        'Error notification multiple messages, Message 2 Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent malesuada libero id odio interdum volutpat. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Praesent vel lectus in mauris viverra venenatis. Nulla sed elit nisl. Cras vitae est varius, vestibulum neque non, accumsan mi. Ut at nulla sagittis, posuere lacus sit amet, lobortis arcu. Donec rhoncus sem vitae elit vehicula hendrerit. Duis ac arcu malesuada magna sodales sollicitudin. Vestibulum luctus sollicitudin arcu, at posuere libero tincidunt et. Curabitur blandit tincidunt maximus. Nam leo urna, venenatis fermentum est sed, sagittis cursus justo.',
                    },

                    {
                      message:
                        'Error notification multiple messages, Message 3',
                      onShowDetailsClick: () => {},
                    },
                  ]}
                  showClose
                />
                <Notification
                  type={NotificationType.Error}
                  messages={[
                    {
                      message: 'Error notification single error',
                      onShowDetailsClick: () => {},
                    },
                  ]}
                  showClose
                />
                <Notification
                  type={NotificationType.Warning}
                  messages={[
                    {
                      message:
                        'Warning notification Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse eu ligula at felis pharetra porta nec et quam. Pellentesque sodales porta egestas. Ut nisl tortor, vulputate at pretium vitae, porttitor quis urna. Vestibulum blandit quam sit amet ullamcorper semper. Quisque id augue in turpis sagittis lobortis. In rutrum lobortis ligula sit amet finibus. Fusce a velit sed ex fringilla efficitur euismod a urna. Donec in neque fermentum, molestie nulla non, dignissim dolor. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Morbi sit amet metus purus.',
                      onShowDetailsClick: () => {},
                    },
                  ]}
                  showClose
                />
                <Notification
                  type={NotificationType.Info}
                  messages={[
                    {
                      message: 'Info notification',
                    },
                  ]}
                  showClose
                />
                <Notification
                  type={NotificationType.Tip}
                  messages={[
                    {
                      message: 'Tip notification',
                      onShowDetailsClick: () => {},
                    },
                  ]}
                  showClose
                />
              </div>

              {/* Toasts */}
              <div style={{ display: 'flex', gap: '20px' }}>
                <button
                  onClick={() => showErrorToast('Error toast')}
                  className="btn btn-outline"
                >
                  <span className="btn-text">Show error toast</span>
                </button>
                <button
                  onClick={() => showSuccessToast('Success toast')}
                  className="btn btn-outline"
                >
                  <span className="btn-text">Show success toast</span>
                </button>
                <button
                  onClick={() => showCartToast('Cart toast')}
                  className="btn btn-outline"
                >
                  <span className="btn-text">Show cart toast</span>
                </button>
                <button
                  onClick={() => showInfoToast('Info toast')}
                  className="btn btn-outline"
                >
                  <span className="btn-text">Show info toast</span>
                </button>

                <button
                  onClick={() => showInfoToast('Toast with close button', true)}
                  className="btn btn-outline"
                >
                  <span className="btn-text">Show toast with close button</span>
                </button>
              </div>
            </div>
            <div className="btn-loader-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </section>

      {/* Content of demo page ends here */}
    </>
  );
}
